/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Self_Organized_DescInputs */



/**
* | output |
* | --- |
* | "players can seat their own pods (open-rounds events)" |
*
* @param {Og_Cfg_Self_Organized_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_self_organized_desc = /** @type {((inputs?: Og_Cfg_Self_Organized_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Self_Organized_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("les joueurs peuvent s'asseoir dans leurs propres pods (événements à rondes libres)")
	if (locale === "es") return /** @type {LocalizedString} */ ("los jugadores pueden sentar sus propios pods (eventos de rondas abiertas)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("jogadores podem sentar seus próprios pods (eventos de rodadas abertas)")
	if (locale === "it") return /** @type {LocalizedString} */ ("i giocatori possono scegliere i propri pod (eventi a round liberi)")
	return /** @type {LocalizedString} */ ("players can seat their own pods (open-rounds events)")
});